import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { API_INFO } from "@client/lib/api";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { onApplied, setShowingModal } from "../../actions";
import { localStateSelector } from "../../selectors";
import { type Leaderboard } from "../../types";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  apiInfo: API_INFO,
  id: "",
  source: "content",
  countryCode: null,
  isVisible: false,
  launchId: ""
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const launchIdSelector = getSettingValueSelector(TargetSelector.Entity, "launchId");

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    if (localState.showingModal?.type !== "Apply") return INVISIBLE_PROPS;

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      countryCode: localState.countryCode,
      isVisible: true,
      launchId: launchIdSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(setShowingModal(getEntityRef(props), null)),
  onSubmitted: (data: Leaderboard.Api.LaunchLeadboardItem) => dispatch(onApplied(getEntityRef(props), data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
